var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalculate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "20px",
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "calculate") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1.0-Early-Settlement-(all-Odds)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sp4e---All-odds-(Early-Settlement-01---collapse)",
    transform: "translate(-21.000000, -268.000000)",
    fill: "#323333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calculate",
    transform: "translate(21.000000, 268.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.445335,0 L2.81110405,0 C1.25925063,0.00172392312 0.00166996344,1.25934832 0,2.8112018 L0,17.1887982 C0.00166996344,18.7406517 1.25925063,19.9982761 2.81110405,20 L14.445335,20 C15.9971884,19.9982761 17.2547691,18.7406517 17.2564391,17.1887982 L17.2564391,2.81071306 C17.2544999,1.25905045 15.9969979,0.00172339806 14.445335,0 L14.445335,0 Z M15.5458677,17.1887982 C15.5453827,17.7964204 15.0529572,18.2888897 14.445335,18.2894287 L2.81110405,18.2894287 C2.20348186,18.2888897 1.71105637,17.7964204 1.71057133,17.1887982 L1.71057133,2.81071306 C1.71132573,2.20328169 2.20367245,1.71110989 2.81110405,1.71057133 L14.445335,1.71057133 C15.0529572,1.71111034 15.5453827,2.20357956 15.5458677,2.8112018 L15.5458677,17.1887982 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 3.22349836,
    y: 3.04853135,
    width: 10.8095401,
    height: 3.06260691,
    rx: 0.4467
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.49762964,
    cy: 8.65578417,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8.60886565,
    cy: 8.65578417,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.7201017,
    cy: 8.65578417,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.49762964,
    cy: 12.0558135,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8.60886565,
    cy: 12.0558135,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.7201017,
    cy: 12.0558135,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.49762964,
    cy: 15.4558428,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8.60886565,
    cy: 15.4558428,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.7201017,
    cy: 15.4558428,
    r: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculate);
export default __webpack_public_path__ + "static/media/calculate.f8926d8bda03714f76617889ade9db99.svg";
export { ForwardRef as ReactComponent };